import axiosInstance from '.';
import { updateMethodProps } from 'src/types/axios.types';

const patchRequest = ({
  url,
  payload,
  loader,
  successFunction,
  errorFunction,
  customHeader,
}: updateMethodProps) => {
  if (loader) {
    loader(true);
  }
  axiosInstance
    .patch(url, payload, customHeader)
    .then((res) => {
      if (successFunction) {
        successFunction(res);
      }
    })
    .catch((error) => {
      // const { response } = error;
      // if (response) {
      //   if (response.data.StatusCode === 401) {
      //     // unAuthorizedException(error, dispatch, postRequest, [url, payload, loader, successFunction, errorFunction])
      //     return;
      //   }
      // }
      if (errorFunction) {
        errorFunction(error);
      }
    })
    .finally(() => {
      if (loader) {
        loader(false);
      }
    });
};

export default patchRequest;
